import { render } from "./trueOrFalse.vue?vue&type=template&id=7f18ba97&scoped=true&ts=true&lang=pug"
import script from "./trueOrFalse.vue?vue&type=script&lang=ts"
export * from "./trueOrFalse.vue?vue&type=script&lang=ts"

import "./trueOrFalse.vue?vue&type=style&index=0&id=7f18ba97&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f18ba97"]])

export default __exports__